import "unfetch/polyfill";

export default function findFeatures(apiUrl, apiKey) {
  return new Promise(function(resolve, reject) {
    fetch(apiUrl + "feature?apiKey=" + apiKey)
      .then(r => r.json())
      .then(data => {
        resolve(data);
      })
      .catch(reason => {
        reject(reason);
      });
  });
}
